import { render } from "./AccountDashboard.vue?vue&type=template&id=0e025fb2&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"

import "./AccountDashboard.vue?vue&type=style&index=0&id=0e025fb2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e025fb2"]])

export default __exports__